import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-009cdc9d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "position-anchor" };
const _hoisted_2 = {
    ref: "containerRef",
    class: "image-container"
};
const _hoisted_3 = {
    ref: "insideRef",
    class: "image-inside"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['image-with-transforms-container', _ctx.blockWidthClass])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, null, 512)
            ], 512)
        ])
    ], 2));
}
